import { c as _c } from "react/compiler-runtime";
import { locale } from "@locale";
import classNames from 'classnames';
import LocationSvg from "src/components/svg/LocationSvg";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from './NoLocation.module.css';

//#region [Props]
type NoLocationProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function NoLocation(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  const locationContext = useLocationContext();
  let t1;
  if ($[0] !== className) {
    const themeStyles = getThemeStyles(styles);
    t1 = classNames(styles.NoLocation, className, themeStyles);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locationContext) {
    t2 = () => locationContext.setShowLocationDialog(true);
    $[2] = locationContext;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LocationSvg className={styles.LocIcon} />;
    t4 = <div className={styles.NoLocText}>{locale.program.noLocation.prompt}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2) {
    t5 = <div className={t1} title={locale.program.noLocation.action} onClick={t2}>{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
//#endregion